// olap-client/src/utils/stripHtml.js
export function stripHtml(html) {
  if (!html) return '';
  
  return html
    // Заменяем <br> и </p> на переносы
    .replace(/<br\s*\/?>/gi, '\n')
    .replace(/<\/p>/gi, '\n')
    .replace(/<p[^>]*>/gi, '')
    // Заменяем табы на пробелы
    .replace(/\t/g, '    ')
    .replace(/&emsp;/g, ' ')
    .replace(/&nbsp;/g, ' ')
    // Удаляем все остальные теги
    .replace(/<[^>]*>/g, '')
    // Декодируем HTML-сущности
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"')
    // Убираем множественные переносы
    .replace(/\n{3,}/g, '\n\n')
    // Убираем лишние пробелы
    .replace(/[ \t]+/g, ' ')
    .trim();
}